import type TokenTransformerFunc from "@ext/markdown/core/edit/logic/Prosemirror/TokenTransformerFunc";

/** The tag transformer names the node after the tag; a comment inside a line is the inline one. */
const sourceCommentTokenTransformer: TokenTransformerFunc = ({ token, parent }) => {
	if (token.type === "source-comment" && parent) return { ...token, type: "inline-source-comment" };
};

export default sourceCommentTokenTransformer;
